

/**
 * Displays the content of the register
 * @param content {number}
 * @param index {number}
 * @returns {JSX.Element}
 * @constructor
 */
export function Register({content, index}) {
    return (
        <div className={'register-container'}>
            {/* content of register */}
            <div className='register-cell p-2 border border-dark border-1'>
                {content.toLocaleString()} {/* display fully w/o science-notation: https://stackoverflow.com/a/33456309 */}
            </div>

            {/* index of register */}
            <div className='px-2'>
                {index}
            </div>
        </div>
    );
}


/**
 * Displays input field of register
 * @param initContent {number} is initial value of input
 * @param index {number} is index of register
 * @param onContentChangedHandler the function that should be called every time the input is changed.
 * It accepts: index of register, new value of register
 * @returns {JSX.Element}
 * @constructor
 */
export function RegisterInput({initContent, index, onValueChangedHandler}){
    const initValue = initContent ? initContent : 0;
    return(
        <div className={'register-container'}>
            <div className='d-inline border border-dark border-1 p-2'>
                <input id={`edit-register-${index}`} type='number' required
                       min='0' step='1' defaultValue={initValue} className='register-input'

                       onChange={(e) => {
                           e.preventDefault();
                           onValueChangedHandler(index, e.target.value);
                       }}/>
            </div>

            <div className={'px-2'}>
                {index}
            </div>
        </div>
    );
}




